import { Header } from "semantic-ui-react";

import React from "react";
import { useNavigate } from "react-router-dom";

import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import useOrdersQuery from "../../hooks/useOrdersQuery";

import useOrdersTableColumns from "./hooks/useOrdersTableColumns";

export default function OrdersView({ header, expense, firstPartyId, cloud, showFirstParty = false }) {
	const navigate = useNavigate();

	const query = useOrdersQuery({ expense, firstPartyId, cloud });
	const columns = useOrdersTableColumns({ showFirstParty });

	return (
		<>
			<div style={{ marginBottom: 15 }}>
				<Header as="h2">{header}</Header>
			</div>

			<CollectionDataTable
				persist
				filterable
				query={query}
				columns={columns}
				onClick={({ id }) => navigate(id)}
				sortable
				sortBy={{
					id: "created",
					desc: true,
				}}
			/>
		</>
	);
}
